/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Ignore_StampsInputs */

const cs_ebr_ignore_stamps = /** @type {(inputs: Ebr_Ignore_StampsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Načíst vše znovu (ignorovat razítka změn)`)
};

const en_ebr_ignore_stamps = /** @type {(inputs: Ebr_Ignore_StampsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fetch everything again (ignore change stamps)`)
};

/**
* | output |
* | --- |
* | "Fetch everything again (ignore change stamps)" |
*
* @param {Ebr_Ignore_StampsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_ignore_stamps = /** @type {((inputs?: Ebr_Ignore_StampsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Ignore_StampsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_ignore_stamps(inputs)
	return cs_ebr_ignore_stamps(inputs)
});